import Grid from '@mui/material/Grid';
import { observer } from 'mobx-react-lite';
import {
  CheckboxField,
  FieldGroup,
  HintBox,
  ImageField,
  SelectField,
  TextField,
} from '../../../../components';
import { getCurrencies } from '../../../../store/constants/currencies';
import { ProductHelp } from '../../../../store/constants/help';
import Product from '../../store/Product';

const DISABLED_TOOLTIP =
  'The field cannot be changed after publishing. ' +
  'Please contact Pulse Admin if you wish to change it.';

export default observer(function GeneralPanel({
  product,
}: {
  product: Product;
}) {
  const disableReadonlyFields = !product.isFullEditAllowed;

  return (
    <form>
      <Grid container spacing={6}>
        <Grid item xs={4}>
          <TextField
            errorText={product.errors.name}
            label="Name"
            name="name"
            onBlur={product.handleBlur}
            onChange={product.handleChange}
            required
            value={product.name}
          />

          <TextField
            errorText={product.errors.tags}
            helperText="Comma separated"
            label="Tags"
            name="tags"
            onBlur={product.handleBlur}
            onChange={product.handleChange}
            value={product.tags}
          />

          <ImageField
            helperText="Please use flat product image not 3D box, suggested size is 400x300"
            label="Cover image"
            onImageSelected={product.handleImageChange}
            value={product.coverUrl}
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            disabled={disableReadonlyFields}
            disabledTooltip={DISABLED_TOOLTIP}
            errorText={product.errors.sku}
            helperText="lowercase with no spaces or unusual symbols"
            label="SKU"
            name="sku"
            onBlur={product.handleBlur}
            onChange={product.handleChange}
            required
            value={product.sku}
          />

          <FieldGroup>
            <TextField
              errorText={product.errors.price}
              label="Price"
              name="price"
              onBlur={product.handleBlur}
              onChange={product.handleChange}
              required
              sx={{ width: 80 }}
              type="number"
              value={product.price}
            />

            <SelectField
              disabled={disableReadonlyFields}
              disabledTooltip={DISABLED_TOOLTIP}
              errorText={product.errors.currency}
              label="Currency"
              name="currency"
              onBlur={product.handleBlur}
              onChange={product.handleChange}
              options={getCurrencies()}
              required
              sx={{ width: 80 }}
              value={product.currency}
            />
          </FieldGroup>

          <div>
            <TextField
              errorText={product.errors.downloadLimit}
              label="Download limit"
              name="downloadLimit"
              onBlur={product.handleBlur}
              onChange={product.handleChange}
              required
              sx={{ width: 136 }}
              type="number"
              value={product.downloadLimit}
            />
          </div>

          <CheckboxField
            errorText={product.errors.inPulseStore}
            label="Publish to Pulse store"
            name="inPulseStore"
            onBlur={product.handleBlur}
            onChange={product.handleChange}
            value={product.inPulseStore}
          />
        </Grid>

        <Grid item xs={4}>
          {!product.isNew && <HintBox help={ProductHelp.changingProduct} />}
          {!product.isNew && <HintBox help={ProductHelp.readOnlyFields} />}
          {product.isNew && <HintBox help={ProductHelp.creatingProduct} />}
        </Grid>
      </Grid>
    </form>
  );
});
